function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(0.000000,511.000000) scale(0.100000,-0.100000)"
}, React.createElement("path", {
  d: "M7765.6,3526.7l-799-799l-53,48.5l-50.8,48.6H3682.3H501.7l-200.9-209.7L100,2403.3v-2205v-2205l200.9-211.9l200.9-209.7h637.9c350.9,0,637.9-6.6,637.9-15.4c0-11-311.2-326.7-688.7-706.3L398-3840.9l132.4-132.4l132.4-132.4L4750.6-18l4089.9,4089.9l-125.8,125.8c-70.6,70.6-132.4,128-139.1,128C8569.1,4325.8,8204.9,3966,7765.6,3526.7z M4437.2,198.3L2185.8-2053.1h-761.5H665l-94.9,92.7l-94.9,92.7V196.1v2063.7l92.7,94.9l92.7,94.9h3015h3012.8L4437.2,198.3z"
}), React.createElement("path", {
  d: "M8608.8,2182.6c-690.8-302.4-1280.2-556.2-1306.7-562.8c-48.6-13.2-50.8-8.8-50.8,158.9V1953l-187.6-187.6l-189.8-189.8l6.6-278.1l6.6-280.3l1313.3,571.7c721.8,315.6,1315.5,573.9,1319.9,573.9c2.2,0,4.4-882.9,4.4-1964.4c0-1079.3-4.4-1964.4-8.8-1964.4c-4.4,0-598.1,258.2-1319.9,571.7L6887.2-622.8l-6.6-631.2l-4.4-631.3l-81.7-83.9l-81.7-83.9H4977.9H3245.3l-187.6-187.6L2870-2428.3h1997.5h1997.5l194.2,207.5l192,209.7v397.3c0,284.7,6.6,399.5,24.3,399.5c15.4,0,604.8-253.8,1313.3-562.8c706.3-309,1291.2-562.8,1297.9-562.8c6.6,0,13.2,1143.3,13.2,2538.3c0,1397.2-6.6,2538.3-15.5,2538.3C9873.5,2734.4,9301.9,2487.2,8608.8,2182.6z"
})));

var SvgNoCamera = function SvgNoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noCamera.29ac4ede.svg";
export { ForwardRef as ReactComponent };